export default __webpack_public_path__ + "atomic/_patterns/03-organisms/banner-carousel/_banner-carousel.twig";